<div class="modal-content">
  <div class="modal-body text-center dicas-foto-verificacao__body">
    <button type="button" class="close pull-right" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
    <img src="../../../../../assets/images/laudo/dicas-foto/ic_light.svg" alt="luz">
    <div class="dicas-foto-verificacao__title">Dicas para uma boa foto!</div>
    <div class="dicas-foto-verificacao__subtitle">Precisa de ajuda para tirar as melhores fotos? Confira algumas dicas abaixo:</div>
    <section class="dicas-foto-verificacao__content">
      <div class="dicas-foto-verificacao__tips light">
        <img class="dicas-foto-verificacao__tips_icon" src="../../../../../assets/images/laudo/dicas-foto/ic_sun.svg" alt="luz">
        <div>
          <div class="dicas-foto-verificacao__tips_title">Ambiente iluminado</div>
          <div class="dicas-foto-verificacao__tips_text">Um ambiente bem iluminado proporciona fotos melhores.</div>
        </div>
      </div>

      <div class="dicas-foto-verificacao__tips square">
        <img class="dicas-foto-verificacao__tips_icon" src="../../../../../assets/images/laudo/dicas-foto/ic_square.svg" alt="square">
        <div>
          <div class="dicas-foto-verificacao__tips_title">Foto nítida</div>
          <div class="dicas-foto-verificacao__tips_text">Toque na tela para marcar o ponto de foco e verifique se sua foto está nítida antes de enviar.</div>
        </div>
      </div>

      <div class="dicas-foto-verificacao__tips landscape">
        <img class="dicas-foto-verificacao__tips_icon" src="../../../../../assets/images/laudo/dicas-foto/ic_cara_limpa.svg" alt="cleanface">
        <div>
          <div class="dicas-foto-verificacao__tips_title">De cara limpa</div>
          <div class="dicas-foto-verificacao__tips_text"><strong>Não utilize</strong> bonés, chapéus, toucas, óculos ou qualquer outro acessório que limite sua identificação.</div>
        </div>
      </div>

      <div class="dicas-foto-verificacao__tips flash">
        <img class="dicas-foto-verificacao__tips_icon" src="../../../../../assets/images/laudo/dicas-foto/ic_no_flash.svg" alt="no-flash">
        <div>
          <div class="dicas-foto-verificacao__tips_title">Evite utilizar o flash</div>
          <div class="dicas-foto-verificacao__tips_text">O flash acabará prejudicando as suas fotos, deixando as cores mais artificiais e adicionando reflexos desnecessários.</div>
        </div>
      </div>

      <div class="dicas-foto-verificacao__tips zoom">
        <img class="dicas-foto-verificacao__tips_icon" src="../../../../../assets/images/laudo/dicas-foto/ic_no_zoom.svg" alt="no-zoom">
        <div>
          <div class="dicas-foto-verificacao__tips_title">Evite dar zoom</div>
          <div class="dicas-foto-verificacao__tips_text">Na maioria dos casos, o zoom diminui a qualidade da foto e acaba prejudicando a sua nitidez e enquadramento</div>
        </div>
      </div>
    </section>
  </div>
  <div class="modal-footer dicas-foto-verificacao__action">
    <button
      type="button"
      class="btn btn-app btn-primary"
      (click)="close()">
      Ok, entendi
    </button>
  </div>
</div>
